import PackingInstructions from "./packingInstructions";

export default PackingInstructions;
